import {Option} from "../atoms/SelectInput.tsx";
import {FC} from "react";
import {Column, WrapRow} from "../atoms/Layout.tsx";
import InputLabel from "../atoms/InputLabel.tsx";
import TogglePill from "../atoms/TogglePill.tsx";

interface Props {
    label: string;
    options: Option[],
    value: string[],
    onChange?: (value: string[]) => void
}

const PillSelectGroup: FC<Props> = ({ label, options, value, onChange }) => {
    const setValueActive = (optionValue: string, active: boolean) => {
        if (onChange) {
            if (active) {
                onChange([...value, optionValue]);
            } else {
                onChange(value.filter(v => v !== optionValue));
            }
        }
    }

    return <Column gap="8">
        <InputLabel>{label}</InputLabel>
        <WrapRow gap="8">
            { options.map((option) => (
                <TogglePill
                    key={option.value}
                    active={value.includes(option.value)}
                    onChange={active => setValueActive(option.value, active)}>
                    {option.label}
                </TogglePill>
            ))}
        </WrapRow>
    </Column>
}

export default PillSelectGroup;